<!-- Purchase Manager Landing Page -->
<div class="pm-landing-container"
  [class.has-cart-bar]="hasCartItems">
  <!-- Header -->
  <div class="pm-header">
    <div class="pm-header-left">
      <div class="pm-header-icon">
        <i class="material-icons"
          style="color: #e6b401; font-size: 28px;">shopping_cart</i>
      </div>
      <div class="pm-header-text">
        <h1 class="pm-title">Purchase Manager</h1>
        <p class="pm-subtitle">Search multiple items, SKUs, or commodities instantly.</p>
      </div>
    </div>
  </div>

  <!-- Search Section -->
  <div class="pm-search-section">
    <div class="pm-search-box"
      [class.focused]="showSearchDropdown">
      <div class="pm-search-input-row">
        <i class="material-icons search-icon">search</i>
        <input type="text"
          #searchInput
          class="pm-search-input"
          [(ngModel)]="searchQuery"
          (input)="onSearchInput()"
          (focus)="showSearchDropdown = searchResults.length > 0"
          (blur)="onSearchBlur()"
          (keydown.enter)="onSearchSubmit()"
          placeholder="Search eg: 'Red Onion 50T', 'Potatoes Grade A'..." />
        <span class="pm-search-shortcut">Ctrl + K</span>
        <button class="pm-search-btn"
          (click)="onSearchNavigate()"
          [disabled]="searchTags.length === 0 && (!searchQuery || searchQuery.length < 2)">
          Search
          <span class="pm-search-count"
            *ngIf="searchTags.length > 0">({{ searchTags.length }})</span>
        </button>
      </div>

      <!-- Search Tags -->
      <div class="pm-search-tags"
        *ngIf="searchTags.length > 0">
        <span class="pm-tag"
          *ngFor="let tag of visibleTags">
          {{ tag.name }}
          <i class="material-icons pm-tag-close"
            (click)="removeSearchTag(tag)">close</i>
        </span>
        <span class="pm-tag-more"
          *ngIf="hiddenTagCount > 0 && !showAllTags"
          (click)="showAllTags = true"
          style="cursor:pointer">
          +{{ hiddenTagCount }} More
        </span>
        <span class="pm-tag-more"
          *ngIf="showAllTags && searchTags.length > 8"
          (click)="showAllTags = false"
          style="cursor:pointer">
          Show less
        </span>
      </div>
    </div>

    <!-- Search Dropdown -->
    <div class="pm-search-dropdown"
      *ngIf="showSearchDropdown">
      <div class="pm-search-loading"
        *ngIf="isSearching">
        <i class="material-icons spin">refresh</i>
        <span>Searching...</span>
      </div>

      <div class="pm-search-empty"
        *ngIf="!isSearching && searchResults.length === 0 && searchQuery.length >= 2">
        No results found for "{{ searchQuery }}"
      </div>

      <div class="pm-search-result"
        *ngFor="let result of searchResults"
        (mousedown)="addSearchTag(result)">
        <div class="result-name">{{ result.itemName || result.item_name || result.name }}</div>
        <div class="result-details"
          *ngIf="result.supplierName || result.supplier_name">
          <span class="result-supplier">{{ result.supplierName || result.supplier_name }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Quick Add Section -->
  <div class="pm-quick-add">
    <h3 class="pm-section-label">Quick Add <i class="material-icons"
        style="font-size: 16px; vertical-align: middle; color: #000000;">flash_on</i></h3>
    <div class="pm-quick-add-pills">
      <button class="pm-pill"
        *ngFor="let category of quickAddCategories"
        [class.active]="category.active"
        (click)="onQuickAddClick(category)">
        <i class="material-icons">{{ category.icon }}</i>
        <span>{{ category.label }}</span>
        <span class="pill-count"
          *ngIf="category.count">({{ category.count }})</span>
        <i class="material-icons pill-close"
          *ngIf="category.active"
          (click)="dismissQuickAdd(category); $event.stopPropagation()">close</i>
      </button>
    </div>
  </div>

  <!-- Udaan Promotional Banner -->
  <div class="pm-udaan-banner">
    <img src="assets/images/udaan-promo-banner.png" alt="Udaan - Flat ₹500 OFF On First 5 Orders" />
  </div>

  <!-- Loading Overlay -->
  <div class="pm-loading"
    *ngIf="isLoading">
    <div class="pm-spinner"></div>
    <span>Loading items...</span>
  </div>

  <!-- Recent Searched Section -->
  <div class="pm-card-section"
    *ngIf="recentPurchases.length > 0 && !isLoading">
    <h3 class="pm-section-title">Recent Searched</h3>
    <div class="pm-card-scroll">
      <div class="pm-product-card"
        *ngFor="let item of recentPurchases">
        <div class="pm-card-image">
          <img [src]="item.imageUrl || 'assets/images/placeholder-product.svg'"
            [alt]="item.name"
            loading="lazy"
            onerror="this.src='assets/images/placeholder-product.svg'" />
        </div>
        <div class="pm-card-body">
          <h4 class="pm-card-name">{{ item.name }}</h4>
          <p class="pm-card-package">{{ item.packageInfo }}</p>
          <div class="pm-card-btn-row"
            *ngIf="isItemAdded(item)">
            <span class="pm-added-label"><i class="material-icons"
                style="font-size: 14px; vertical-align: middle;">check</i> Added</span>
            <button class="pm-remove-btn"
              (click)="removeFromSearch(item)"
              title="Remove from search">
              <i class="material-icons">delete_outline</i>
            </button>
          </div>
          <button class="pm-add-search-btn"
            *ngIf="!isItemAdded(item)"
            (click)="addToSearch(item)">
            Add to Search
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Most Searched Section -->
  <div class="pm-card-section"
    *ngIf="mostSearchedItems.length > 0 && !isLoading">
    <h3 class="pm-section-title">Most Searched</h3>
    <div class="pm-card-scroll">
      <div class="pm-product-card"
        *ngFor="let item of mostSearchedItems">
        <div class="pm-card-image">
          <img [src]="item.imageUrl || 'assets/images/placeholder-product.svg'"
            [alt]="item.name"
            loading="lazy"
            onerror="this.src='assets/images/placeholder-product.svg'" />
        </div>
        <div class="pm-card-body">
          <h4 class="pm-card-name">{{ item.name }}</h4>
          <p class="pm-card-package">{{ item.packageInfo }}</p>
          <div class="pm-card-btn-row"
            *ngIf="isItemAdded(item)">
            <span class="pm-added-label"><i class="material-icons"
                style="font-size: 14px; vertical-align: middle;">check</i> Added</span>
            <button class="pm-remove-btn"
              (click)="removeFromSearch(item)"
              title="Remove from search">
              <i class="material-icons">delete_outline</i>
            </button>
          </div>
          <button class="pm-add-search-btn"
            *ngIf="!isItemAdded(item)"
            (click)="addToSearch(item)">
            Add to Search
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Trending Near You Section -->
  <div class="pm-card-section"
    *ngIf="trendingItems.length > 0 && !isLoading">
    <h3 class="pm-section-title">Trending near you</h3>
    <div class="pm-card-scroll">
      <div class="pm-product-card"
        *ngFor="let item of trendingItems">
        <div class="pm-card-image">
          <img [src]="item.imageUrl || 'assets/images/placeholder-product.svg'"
            [alt]="item.name"
            loading="lazy"
            onerror="this.src='assets/images/placeholder-product.svg'" />
        </div>
        <div class="pm-card-body">
          <h4 class="pm-card-name">{{ item.name }}</h4>
          <p class="pm-card-package">{{ item.packageInfo }}</p>
          <div class="pm-card-btn-row"
            *ngIf="isItemAdded(item)">
            <span class="pm-added-label"><i class="material-icons"
                style="font-size: 14px; vertical-align: middle;">check</i> Added</span>
            <button class="pm-remove-btn"
              (click)="removeFromSearch(item)"
              title="Remove from search">
              <i class="material-icons">delete_outline</i>
            </button>
          </div>
          <button class="pm-add-search-btn"
            *ngIf="!isItemAdded(item)"
            (click)="addToSearch(item)">
            Add to Search
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div class="pm-empty-state"
    *ngIf="!isLoading && recentPurchases.length === 0 && mostSearchedItems.length === 0 && trendingItems.length === 0">
    <i class="material-icons">shopping_basket</i>
    <h3>No items found</h3>
    <p>Start by searching for items or use Quick Add to get started.</p>
  </div>

  <!-- Bottom Cart Bar -->
  <div class="bottom-cart-bar"
    *ngIf="hasCartItems">
    <div class="cart-total-section">
      <button class="cart-icon-btn"
        (click)="goToPriceDiscovery()">
        <svg width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none">
          <path
            d="M7.4 17C6.84 17 6.4 17.44 6.4 18C6.4 18.56 6.84 19 7.4 19C7.96 19 8.4 18.56 8.4 18C8.4 17.44 7.96 17 7.4 17ZM17.4 17C16.84 17 16.4 17.44 16.4 18C16.4 18.56 16.84 19 17.4 19C17.96 19 18.4 18.56 18.4 18C18.4 17.44 17.96 17 17.4 17ZM15.9 14.5C16.65 14.5 17.29 14.07 17.6 13.43L20.8 7.64C20.89 7.47 20.9 7.28 20.9 7.1C20.9 6.55 20.45 6.1 19.9 6.1H6.62L5.68 4.1H2.4V6.1H4.4L8.01 13.68L6.72 16.03C6.49 16.44 6.4 16.92 6.4 17.43C6.4 18.3 7.12 19.03 8 19.03H19.4V17.03H8.42C8.28 17.03 8.16 16.91 8.16 16.77L8.2 16.62L9.31 14.6L15.9 14.5V14.5Z"
            fill="#333" />
        </svg>
      </button>
      <div class="cart-total-info">
        <span class="cart-label">CART VALUE</span>
        <span class="cart-value">₹{{ totalCartValue.toFixed(2) }}</span>
      </div>
      <button class="scroll-btn left"
        (click)="scrollCarts('left')">
        <i class="material-icons">chevron_left</i>
      </button>
    </div>

    <div class="supplier-carts-wrapper">
      <div class="supplier-carts-container"
        #cartsContainer>
        <div class="supplier-cart-card"
          *ngFor="let cart of supplierCartData">
          <div class="cart-provider-logo">
            <ng-container [ngSwitch]="cart.platform">
              <span class="provider-icon ud-icon" *ngSwitchCase="'udaan'">
                <img src="assets/images/udaan_cart.png" alt="Udaan" onerror="this.style.display='none'">
              </span>
              <span class="provider-icon hp-icon" *ngSwitchCase="'hyperpure'">
                <img src="assets/images/hyperpure_cart.png" alt="Hyperpure" onerror="this.style.display='none'">
              </span>
              <span class="provider-icon dm-icon" *ngSwitchCase="'dmart'">
                <img src="assets/images/dmart_cart.png" alt="DMart" onerror="this.style.display='none'">
              </span>
            </ng-container>
          </div>
          <div class="cart-provider-info">
            <span class="provider-name">{{ cart.supplierName | uppercase }}</span>
            <div class="provider-cart-meta">
              <span class="provider-cart-value">₹{{ cart.totalValue.toFixed(2) }}</span>
              <span class="provider-cart-items">{{ cart.totalCount }} {{ cart.totalCount === 1 ? 'item' : 'items' }}</span>
            </div>
          </div>
          <button class="checkout-btn"
            (click)="proceedToBuy(cart.platform)">PROCEED TO BUY</button>
        </div>
      </div>
      <button class="scroll-btn right"
        (click)="scrollCarts('right')">
        <i class="material-icons">chevron_right</i>
      </button>
    </div>
  </div>

  <!-- Bottom Cart Bar -->
  <div class="bottom-cart-bar"
    *ngIf="hasCartItems"> 
    <div class="cart-total-section">
      <button class="cart-icon-btn"
        (click)="goToPriceDiscovery()">
        <svg width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none">
          <path
            d="M7.4 17C6.84 17 6.4 17.44 6.4 18C6.4 18.56 6.84 19 7.4 19C7.96 19 8.4 18.56 8.4 18C8.4 17.44 7.96 17 7.4 17ZM17.4 17C16.84 17 16.4 17.44 16.4 18C16.4 18.56 16.84 19 17.4 19C17.96 19 18.4 18.56 18.4 18C18.4 17.44 17.96 17 17.4 17ZM15.9 14.5C16.65 14.5 17.29 14.07 17.6 13.43L20.8 7.64C20.89 7.47 20.9 7.28 20.9 7.1C20.9 6.55 20.45 6.1 19.9 6.1H6.62L5.68 4.1H2.4V6.1H4.4L8.01 13.68L6.72 16.03C6.49 16.44 6.4 16.92 6.4 17.43C6.4 18.3 7.12 19.03 8 19.03H19.4V17.03H8.42C8.28 17.03 8.16 16.91 8.16 16.77L8.2 16.62L9.31 14.6L15.9 14.5V14.5Z"
            fill="#333" />
        </svg>
      </button>
      <div class="cart-total-info">
        <span class="cart-label">CART VALUE</span>
        <span class="cart-value">₹{{ totalCartValue.toFixed(2) }}</span>
      </div>
      <button class="scroll-btn left"
        (click)="scrollCarts('left')">
        <i class="material-icons">chevron_left</i>
      </button>
    </div>

    <div class="supplier-carts-wrapper">
      <div class="supplier-carts-container"
        #cartsContainer>
        <div class="supplier-cart-card"
          *ngFor="let cart of supplierCartData">
          <div class="cart-provider-logo">
            <ng-container [ngSwitch]="cart.platform">
              <span class="provider-icon ud-icon" *ngSwitchCase="'udaan'">
                <img src="assets/images/udaan_cart.png" alt="Udaan" onerror="this.style.display='none'">
              </span>
              <span class="provider-icon hp-icon" *ngSwitchCase="'hyperpure'">
                <img src="assets/images/hyperpure_cart.png" alt="Hyperpure" onerror="this.style.display='none'">
              </span>
              <span class="provider-icon dm-icon" *ngSwitchCase="'dmart'">
                <img src="assets/images/dmart_cart.png" alt="DMart" onerror="this.style.display='none'">
              </span>
            </ng-container>
          </div>
          <div class="cart-provider-info">
            <span class="provider-name">{{ cart.supplierName | uppercase }}</span>
            <div class="provider-cart-meta">
              <span class="provider-cart-value">₹{{ cart.totalValue.toFixed(2) }}</span>
              <span class="provider-cart-items">{{ cart.totalCount }} {{ cart.totalCount === 1 ? 'item' : 'items' }}</span>
            </div>
          </div>
          <button class="checkout-btn"
            (click)="proceedToBuy(cart.platform)">PROCEED TO BUY</button>
        </div>
      </div>
      <button class="scroll-btn right"
        (click)="scrollCarts('right')">
        <i class="material-icons">chevron_right</i>
      </button>
    </div>
  </div>

</div>

<!-- Hyperpure Supplier Child Component (handles iframe overlay) -->
<app-hyperpure-supplier #hyperpureSupplier
  [entityId]="selectedEntityId"
  [storeUuid]="hyperpureStoreUuid"
  (iframeClosed)="onIframeClosed()">
</app-hyperpure-supplier>

<!-- DMart Supplier Child Component (headless) -->
<app-dmart-supplier #dmartSupplier></app-dmart-supplier>

<!-- Udaan Supplier Child Component (headless) -->
<app-udaan-supplier #udaanSupplier
  [entityId]="selectedEntityId"
  [storeUuid]="hyperpureStoreUuid"
  [apiStoreId]="udaanApiStoreId">
</app-udaan-supplier>

<app-profile-setup-modal></app-profile-setup-modal>
